// initial state
const state = {
  lastActive: null,
  idleWaitPeriod: process.env.VUE_APP_IDLE_RESET_SECONDS
}

// getters
const getters = {
  lastActive: state => {
    return state.lastActive
  },

  idleWaitPeriod: state => {
    return state.idleWaitPeriod
  }
}

// actions
const actions = {
  log ({ commit }) {
    commit('setLastActive', Math.round(new Date() / 1000))
  }
}

// mutations
const mutations = {
  setLastActive (state, lastActive) {
    state.lastActive = lastActive
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
